/* eslint-disable arrow-body-style */
import React from 'react';
import { ICommonTableHeaderProps } from './type';
import SortPopover from '../../../PerformanceMetricsTable/components/SortPopover';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';
import { PLACEMENT_MAP } from './config';
import { SortBy } from '../../../PerformanceMetricsTable';
import { convertSortFormat } from '../../utils';
import { useLocal } from '@/pages/dashboard/utils/customHook';

/**
 * 公共表格表头组件
 * 注意：该组件仅适用于 mode: 'single' 模式和 keepDataSource: false 的情况
 * 
 * @param props 
 * @returns 
 */
export default function CommonTableHeader(props: ICommonTableHeaderProps) {
  const { className, style, sortHeaderCellProps, onSortChange: parentOnSortChange } = props;
  const {
    column,
    children,
    /** 这边是 ali-react-table 的，可能值为 asc, desc, none */
    // TODO: 之后需要支持 asc_by_rate, desc_by_rate
    sortOrder,
    sortOptions,
  } = sortHeaderCellProps || {};

  const { align, features } = column || {};
  const { revertSort, cell } = features || {};
  const { isEN } = useLocal();
  const headerIcon = (cell as Record<string, unknown> | undefined)?.headerIcon as string | undefined;
  const explainText = isEN
    ? (features as Record<string, unknown> | undefined)?.explainEn as string | undefined
    : (features as Record<string, unknown> | undefined)?.explainCn as string | undefined;

  const renderHeaderIcon = () => {
    if (!headerIcon) return null;
    return (
      <img
        className="dbd-common-table__header-icon"
        src={headerIcon}
        alt=""
      />
    );
  };

  const renderArrow = () => {
    if (sortOrder?.includes('asc')) return <SvgIcon type={`arrow-other-${revertSort ? 'down' : 'up'}`} />;
    if (sortOrder?.includes('desc')) return <SvgIcon type={`arrow-other-${revertSort ? 'up' : 'down'}`} />;
    return <div className="dbd-common-table__header-sort-icon"></div>;
  };

  const renderSortHeader = () => {
    return (
      <div
        // 插入 header-click-column.code 以便使用 SortPopover
        className={classNames('dbd-common-table__header-sort-clickable', `header-click-${column?.code}`, {
          'is-active': sortOrder !== 'none',
          'dbd-common-table__header-sort-clickable-left': align === 'left',
          'dbd-common-table__header-sort-clickable-right': align === 'right',
          'dbd-common-table__header-sort-clickable-center': align === 'center',
        })}
      >
        {renderHeaderIcon()}
        {explainText ? (
          <CommonBubble placement="top" content={explainText}>
            <span className="dbd-common-table__header-explain">{children}</span>
          </CommonBubble>
        ) : children}
        {renderArrow()}
      </div>
    );
  };

  const placement = PLACEMENT_MAP[align || 'center'] || 'bottom';

  return (
    <div
      className={classNames('dbd-common-table__header', className)}
      style={style}
    >
      {/* SortPopover 原本针对 tea 组件开发，其中 sortOrder 默认为 default，但 ali-react-table 默认为 none，需额外适配 */}
      <SortPopover
        col={{...column, key: column?.code}}
        sorting={{
          defaultSorts: convertSortFormat(sortOptions?.sorts || [], 'popover', { revertSort }),
          onSortChange: (sorts: SortBy[]) => {
            parentOnSortChange?.(convertSortFormat(sorts, 'ali', { revertSort }));
          },
        }}
        showCopyOptions={false}
        useNewActiveLogic={true}
        getRealSort={() => {}}
        value={renderSortHeader()}
        placement={placement}
      />
    </div>
  );
}
